import { useParams } from "react-router-dom";
import "./BlogPost.css";

const posts = {
  "test-post": {
    title: "Stop Guessing Where Work Happens",
    summary: [
      "Employees often clock in without actually being on site",
      "Manual time tracking leads to payroll errors",
      "Location verification removes uncertainty",
      "Automated logging saves time and reduces disputes"
    ],
    content: [
      {
        type: "paragraph",
        text: "Most workforce systems rely on trust. Employees clock in, submit hours, and managers assume the data is correct."
      },
      {
        type: "image",
        src: "/images/hero-dashboard.png",
        alt: "Dashboard preview"
      },
      {
        type: "paragraph",
        text: "But without verification, there’s no way to know if work actually happened where it was supposed to."
      },
      {
        type: "heading",
        text: "Why this matters"
      },
      {
        type: "image",
        src: "/images/hero-dashboard.png",
        alt: "Tracking system"
      },
      {
        type: "paragraph",
        text: "Inaccurate time tracking leads to payroll errors, compliance issues, and lost revenue."
      }
    ]
  },

  "zero-waste-fridge": {
    title: "Zero-Waste Fridge Progress Report",
    summary: [
      "Developing a smart refrigerator that tracks food and reduces waste",
      "AI and sensors used to scan receipts and monitor expiration dates",
      "Multiple teams coordinated across engineering, legal, marketing, and operations",
      "Prototype and investor presentation currently in progress"
    ],
    content: [
      { type: "heading", text: "Introduction" },
      {
        type: "paragraph",
        text: "Ending world hunger starts with us. The routine nature of grocery shopping often leads people to overlook what they already have at home."
      },
      { type: "heading", text: "Project Overview" },
      {
        type: "paragraph",
        text: "The Zero-Waste Fridge uses AI and sensors to track food inventory, monitor expiration dates, and reduce waste."
      },
      {
        type: "image",
        src: "/images/blogPost/figure_1.png",
        alt: "Fridge design"
      },
      { type: "heading", text: "Work Completed" },
      {
        type: "paragraph",
        text: "The team completed research on patents, compliance, and financial models. Engineering achieved early AI accuracy of 86%."
      },
      { type: "heading", text: "Current Work" },
      {
        type: "paragraph",
        text: "The system is now being integrated using Raspberry Pi and sensor testing."
      },
      {
        type: "image",
        src: "/images/blogPost/figure_2.png",
        alt: "Ad mockup"
      },
      { type: "heading", text: "Conclusion" },
      {
        type: "paragraph",
        text: "The project is progressing toward a functional prototype and investor presentation."
      }
    ]
  },
  "aaemployee": {
    title: "AAEmployee",
    summary: [
      "Verify where employees actually clock in",
      "Automatically track hours and location",
      "Eliminate payroll disputes",
      "Built for workforce accountability"
    ],
    content: [

      {
        type: "image",
        src: process.env.PUBLIC_URL + "/images/blogPost/admin_dashboard.png",
        alt: "Admin dashboard"
      },
      {
        type: "paragraph",
        text: "The admin dashboard provides a centralized control panel to manage employees, clients, schedules, and payroll."
      },

      {
        type: "image",
        src: "/images/blogPost/clientspage.png",
        alt: "Clients page"
      },
      {
        type: "paragraph",
        text: "Clients are organized with key details like address, service type, and scheduling status for quick oversight."
      },

      {
        type: "image",
        src: "/images/blogPost/add_employee.png",
        alt: "Add employee"
      },
      {
        type: "paragraph",
        text: "Admins can quickly register employees with validated input fields, ensuring clean and reliable data."
      },

      {
        type: "image",
        src: "/images/blogPost/scheduler_fullsize.png",
        alt: "Scheduler"
      },
      {
        type: "paragraph",
        text: "The scheduler provides a full calendar view for assigning shifts and managing workforce availability."
      },

      {
        type: "image",
        src: "/images/blogPost/schedulerwidget.png",
        alt: "Scheduler widget"
      },
      {
        type: "paragraph",
        text: "A focused scheduling widget allows precise shift creation with employee, client, and time selection."
      },

      {
        type: "image",
        src: "/images/blogPost/PayrollManager.png",
        alt: "Payroll manager"
      },
      {
        type: "paragraph",
        text: "Payroll is automatically generated and tracked, reducing manual errors and ensuring accurate compensation."
      },

      {
        type: "image",
        src: window.location.origin + "/images/blogPost/admin_dashboard.png",
        alt: "Admin activity"
      },
      {
        type: "paragraph",
        text: "Live activity tracking allows admins to monitor employee status and actions in real time."
      },

      {
        type: "image",
        src: "/images/blogPost/employee_dashboard.png",
        alt: "Employee dashboard"
      },
      {
        type: "paragraph",
        text: "Employees have a simple dashboard to view their status, schedules, and work session details."
      },

      {
        type: "image",
        src: "/images/blogPost/employee_clockin.png",
        alt: "Employee clock in"
      },
      {
        type: "paragraph",
        text: "Clock-in is verified by location, ensuring employees are physically present before starting work."
      }

    ]
  }
};

const BlogPost = () => {
  const { slug } = useParams();
  console.log("slug:", slug);
  const post = posts[slug];

  if (!post) {
    return <div style={{ padding: "40px" }}>Post not found</div>;
  }

  return (
    <div className="blog-container">

      {/* Title */}
      <h1 className="blog-title">{post.title}</h1>

      {/* Summary (matches your required structure) */}
      <div className="blog-summary">
        <p className="blog-summary-text">
          <strong>Blog summary:</strong>
        </p>
        <ul className="blog-summary-list">
          {post.summary.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>

      {/* Content */}
      {post.content.map((block, i) => {
        if (block.type === "image") {
          return (
            <img
              key={i}
              src={block.src}
              alt={block.alt}
              className="blog-image"
            />
          );
        }

        if (block.type === "heading") {
          return (
            <h2 key={i} className="blog-heading">
              {block.text}
            </h2>
          );
        }

        if (block.type === "paragraph") {
          return (
            <p key={i} className="blog-paragraph">
              {block.text}
            </p>
          );
        }

        return null;
      })}
    </div>
  );
};

export default BlogPost;